/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for passing arguments for importing a CredentialSchema.
 */
export interface SchemaImportDataRequest {
    schema: Truvity.ClaimsSchema;
    /** Slug of a CredentialSchema. */
    slug?: string;
    /** The version of the resource. */
    version?: number;
}
